export enum ChangeType {
  PROPERTY = 'Property Change',
  ADDED = 'Added to List',
  REMOVED = 'Removed from List'
}
